export default __webpack_public_path__ + "static/media/profile-placeholder.b1b2694e.png";